function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { assign, setup, fromPromise, sendTo } from 'xstate';
// --- Type Guard Helpers ---
var hasOutput = function(e) {
    return e !== null && (typeof e === "undefined" ? "undefined" : _type_of(e)) === 'object' && 'output' in e;
};
var hasError = function(e) {
    return e !== null && (typeof e === "undefined" ? "undefined" : _type_of(e)) === 'object' && 'error' in e;
};
// --- Helper Function (머신 외부 또는 유틸리티로 이동 권장) ---
var mapApiSectionDetailToStoreSection = function(apiSection) {
    var _apiSection_lectures;
    return {
        id: String(apiSection.id),
        title: apiSection.title || '',
        order: apiSection.order !== undefined ? parseInt(String(apiSection.order)) : undefined,
        lessons: ((_apiSection_lectures = apiSection.lectures) === null || _apiSection_lectures === void 0 ? void 0 : _apiSection_lectures.map(function(l) {
            return {
                id: String(l.id),
                title: l.title || '',
                order: typeof l.order === 'string' ? parseInt(l.order) : typeof l.order === 'number' ? l.order : undefined,
                contentType: l.contentType,
                platformSupport: l.platformSupport,
                duration: typeof l.duration === 'string' ? parseInt(l.duration) : typeof l.duration === 'number' ? l.duration : undefined,
                videoUrl: l.videoUrl || undefined,
                markdownUrl: l.markdownUrl || undefined,
                markdown: ''
            };
        })) || []
    };
};
// --- Actor Logic Definitions ---
// const fetchCourseActor = ...; // 직접 invoke 안 함
var saveCourseActor = fromPromise(/*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(param) {
        var input;
        return _ts_generator(this, function(_state) {
            input = param.input;
            if (!input.deps.saveCourseDraft) throw new Error("saveCourseDraft dependency not provided");
            return [
                2,
                input.deps.saveCourseDraft(input.courseId, input.data)
            ];
        });
    });
    return function(_) {
        return _ref.apply(this, arguments);
    };
}());
var publishCourseActor = fromPromise(/*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(param) {
        var input;
        return _ts_generator(this, function(_state) {
            input = param.input;
            if (!input.deps.publishCourse) throw new Error("publishCourse dependency not provided");
            return [
                2,
                input.deps.publishCourse(input.courseId)
            ];
        });
    });
    return function(_) {
        return _ref.apply(this, arguments);
    };
}());
// 머신 setup
export var courseEditPageMachine = setup({
    types: {
        context: {},
        events: {},
        input: {},
        children: {
        }
    },
    actors: {
        // fetchCourseActor: fetchCourseActor, // 직접 invoke 안 함
        saveCourseActor: saveCourseActor,
        publishCourseActor: publishCourseActor
    },
    actions: {
        assignLoadedCourseData: assign(function(param) {
            var event = param.event;
            var courseData = event.courseData;
            var _courseData_updatedAt;
            return {
                courseData: courseData,
                fetchLoading: false,
                fetchError: null,
                courseId: String(courseData.id),
                lastSavedTimestamp: (_courseData_updatedAt = courseData.updatedAt) !== null && _courseData_updatedAt !== void 0 ? _courseData_updatedAt : Date.now()
            };
        }),
        assignLoadingFailedError: assign(function(param) {
            var event = param.event;
            var error = event.error;
            return {
                courseData: null,
                fetchLoading: false,
                fetchError: error || 'Failed to load course'
            };
        }),
        assignSaveSuccess: assign(function(param) {
            var context = param.context, event = param.event;
            if (hasOutput(event)) {
                var out = event.output;
                var _out_updatedAt, _out_id;
                return {
                    saveLoading: false,
                    saveError: null,
                    lastSavedTimestamp: (_out_updatedAt = out.updatedAt) !== null && _out_updatedAt !== void 0 ? _out_updatedAt : Date.now(),
                    courseId: (_out_id = out.id) !== null && _out_id !== void 0 ? _out_id : context.courseId,
                    courseData: out,
                    isBasicInfoDirty: false,
                    isCurriculumDirty: false
                };
            }
            return {};
        }),
        assignSaveError: assign(function(param) {
            var event = param.event;
            return {
                saveLoading: false,
                saveError: hasError(event) ? _instanceof(event.error, Error) ? event.error.message : event.error : 'Failed to save course'
            };
        }),
        assignPublishSuccess: assign(function(param) {
            var context = param.context;
            var // 토스트 메시지 표시
            _context_dependencies_curriculumMachineDependencies_toastSuccess, _context_dependencies_curriculumMachineDependencies, _context_dependencies;
            (_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : (_context_dependencies_curriculumMachineDependencies = _context_dependencies.curriculumMachineDependencies) === null || _context_dependencies_curriculumMachineDependencies === void 0 ? void 0 : (_context_dependencies_curriculumMachineDependencies_toastSuccess = _context_dependencies_curriculumMachineDependencies.toastSuccess) === null || _context_dependencies_curriculumMachineDependencies_toastSuccess === void 0 ? void 0 : _context_dependencies_curriculumMachineDependencies_toastSuccess.call(_context_dependencies_curriculumMachineDependencies, '강의가 성공적으로 게시되었습니다!');
            return {
                publishLoading: false,
                publishError: null,
                courseData: context.courseData ? _object_spread_props(_object_spread({}, context.courseData), {
                    isPublished: true
                }) : context.courseData
            };
        }),
        assignPublishError: assign(function(param) {
            var event = param.event;
            return {
                publishLoading: false,
                publishError: hasError(event) ? _instanceof(event.error, Error) ? event.error.message : event.error : 'Failed to publish course'
            };
        }),
        updateCourseTitle: assign(function(param) {
            var context = param.context, event = param.event;
            if (event.type === 'UPDATE_TITLE') {
                var _context_courseData;
                console.log('[courseEditPageMachine] Updating title. Current:', (_context_courseData = context.courseData) === null || _context_courseData === void 0 ? void 0 : _context_courseData.title, 'New:', event.title);
                if (context.courseId === 'new' && !context.courseData) {
                    return {
                        courseData: {
                            id: 'new',
                            title: event.title,
                            description: '',
                            level: 'BEGINNER',
                            isPublished: false
                        }
                    };
                }
                if (!context.courseData) return {};
                return {
                    courseData: _object_spread_props(_object_spread({}, context.courseData), {
                        title: event.title
                    })
                };
            }
            return {};
        }),
        updateDescriptionInContext: assign(function(param) {
            var context = param.context, event = param.event;
            if (event.type === 'UPDATE_DESCRIPTION') {
                var _context_courseData;
                var _context_courseData_description;
                var currentDesc = (_context_courseData_description = (_context_courseData = context.courseData) === null || _context_courseData === void 0 ? void 0 : _context_courseData.description) !== null && _context_courseData_description !== void 0 ? _context_courseData_description : '';
                // if (event.description === currentDesc && context.courseData) return {}; 
                console.log("[courseEditPageMachine] updateDescriptionInContext. Current: '".concat(currentDesc, "', New: '").concat(event.description, "', State: ").concat(context.courseId === 'new' ? 'editingNew' : 'editingExisting'));
                if (context.courseId === 'new' && !context.courseData) {
                    return {
                        courseData: {
                            id: 'new',
                            title: '',
                            description: event.description,
                            level: 'BEGINNER',
                            isPublished: false
                        }
                    };
                }
                if (!context.courseData) return {};
                return {
                    courseData: _object_spread_props(_object_spread({}, context.courseData), {
                        description: event.description
                    })
                };
            }
            return {};
        }),
        updateLevelInContext: assign(function(param) {
            var context = param.context, event = param.event;
            if (event.type === 'UPDATE_LEVEL') {
                var _context_courseData;
                console.log('[courseEditPageMachine] Updating level. Current:', (_context_courseData = context.courseData) === null || _context_courseData === void 0 ? void 0 : _context_courseData.level, 'New:', event.level);
                var newLevel = event.level; // event.level은 이미 PageCourseData['level'] 타입이어야 함
                if (context.courseId === 'new' && !context.courseData) {
                    return {
                        courseData: {
                            id: 'new',
                            title: '',
                            description: '',
                            level: newLevel,
                            isPublished: false
                        }
                    };
                }
                if (!context.courseData) return {};
                return {
                    courseData: _object_spread_props(_object_spread({}, context.courseData), {
                        level: newLevel
                    })
                };
            }
            return {};
        }),
        updateThumbnailInContext: assign(function(param) {
            var context = param.context, event = param.event;
            if (event.type === 'UPDATE_THUMBNAIL') {
                var _context_courseData;
                console.log('[courseEditPageMachine] Updating thumbnail. Current:', (_context_courseData = context.courseData) === null || _context_courseData === void 0 ? void 0 : _context_courseData.thumbnailUrl, 'New:', event.thumbnailUrl);
                var newThumbnailUrl = event.thumbnailUrl;
                if (context.courseId === 'new' && !context.courseData) {
                    return {
                        courseData: {
                            id: 'new',
                            title: '',
                            description: '',
                            level: 'BEGINNER',
                            thumbnailUrl: newThumbnailUrl,
                            isPublished: false
                        }
                    };
                }
                if (!context.courseData) return {};
                return {
                    courseData: _object_spread_props(_object_spread({}, context.courseData), {
                        thumbnailUrl: newThumbnailUrl
                    })
                };
            }
            return {};
        }),
        spawnCurriculumActor: assign(function(param) {
            var context = param.context, spawn = param.spawn;
            if (context.curriculumActorRef) return {};
            var actor = spawn(context.dependencies.curriculumMachine, {
                id: 'curriculumActor',
                input: {
                    courseId: context.courseId,
                    dependencies: context.dependencies.curriculumMachineDependencies
                }
            });
            return {
                curriculumActorRef: actor
            };
        }),
        sendInitialDataToCurriculum: sendTo('curriculumActor', function(param) {
            var context = param.context;
            var _context_courseData_sections, _context_courseData;
            return {
                type: 'INITIALIZE_CURRICULUM',
                initialSections: ((_context_courseData = context.courseData) === null || _context_courseData === void 0 ? void 0 : (_context_courseData_sections = _context_courseData.sections) === null || _context_courseData_sections === void 0 ? void 0 : _context_courseData_sections.map(mapApiSectionDetailToStoreSection)) || [],
                courseId: context.courseId
            };
        }),
        forwardToCurriculumActor: sendTo('curriculumActor', function(param) {
            var event = param.event;
            return event.event;
        }),
        updateCurriculumStateFromChild: assign(function(param) {
            var event = param.event;
            return {
                isCurriculumDirty: event.isDirty
            };
        }),
        // setFetchLoadingTrue: assign({ fetchLoading: true, fetchError: null }), // fetchLoading은 context 초기값 또는 SET_LOADED_COURSE/FAILED로 관리
        setSaveLoadingTrue: assign({
            saveLoading: true,
            saveError: null
        }),
        setPublishLoadingTrue: assign({
            publishLoading: true,
            publishError: null
        }),
        updateCurrentTab: assign({
            currentTab: function(param) {
                var event = param.event;
                return event.tab;
            }
        }),
        updateBasicInfoDirty: assign({
            isBasicInfoDirty: function(param) {
                var event = param.event;
                return event.isDirty;
            }
        })
    },
    guards: {
        isNewCourse: function(param) {
            var context = param.context;
            return context.courseId === 'new';
        },
        isCourseSavable: function(param) {
            var context = param.context;
            console.log('[courseEditPageMachine] Checking isCourseSavable:', {
                isBasicInfoDirty: context.isBasicInfoDirty,
                isCurriculumDirty: context.isCurriculumDirty,
                result: context.isBasicInfoDirty || context.isCurriculumDirty
            });
            return context.isBasicInfoDirty || context.isCurriculumDirty;
        },
        isCourseLoadedAndPublishable: function(param) {
            var context = param.context;
            return !!context.courseData && context.courseId !== 'new';
        }
    }
}).createMachine({
    id: 'courseEditPage',
    context: function(param) {
        var input = param.input;
        return {
            courseId: input.courseId,
            courseData: null,
            fetchLoading: true,
            fetchError: null,
            saveLoading: false,
            saveError: null,
            publishLoading: false,
            publishError: null,
            lastSavedTimestamp: null,
            currentTab: 'edit',
            isBasicInfoDirty: false,
            isCurriculumDirty: false,
            dependencies: input.dependencies,
            curriculumActorRef: undefined
        };
    },
    initial: 'waitingForInitialData',
    states: {
        waitingForInitialData: {
            entry: function() {
                return console.log('[XState] Entering state: waitingForInitialData');
            },
            always: [
                {
                    guard: 'isNewCourse',
                    target: 'editingNewPrepare',
                    actions: assign({
                        fetchLoading: false
                    })
                }
            ],
            on: {
                SET_LOADED_COURSE: {
                    target: 'editingExistingPrepare',
                    actions: 'assignLoadedCourseData'
                },
                SET_LOADING_FAILED: {
                    target: 'loadingFailed',
                    actions: 'assignLoadingFailedError'
                }
            }
        },
        editingNewPrepare: {
            entry: [
                function() {
                    return console.log('[XState] Entering state: editingNewPrepare');
                },
                'spawnCurriculumActor'
            ],
            always: {
                target: 'editingNew'
            }
        },
        editingExistingPrepare: {
            entry: [
                function() {
                    return console.log('[XState] Entering state: editingExistingPrepare');
                },
                'spawnCurriculumActor',
                'sendInitialDataToCurriculum'
            ],
            always: {
                target: 'editingExisting'
            }
        },
        loadingFailed: {
            entry: [
                function() {
                    return console.log('[XState] Entering state: loadingFailed');
                }
            ],
            on: {
            }
        },
        editingNew: {
            entry: [
                function() {
                    return console.log('[XState] Entering state: editingNew');
                },
                sendTo('curriculumActor', function() {
                    return {
                        type: 'INITIALIZE_CURRICULUM',
                        courseId: 'new',
                        initialSections: []
                    };
                })
            ],
            on: {
                SAVE_COURSE: {
                    target: 'savingCourse',
                    actions: 'setSaveLoadingTrue'
                },
                UPDATE_TITLE: {
                    actions: 'updateCourseTitle'
                },
                UPDATE_DESCRIPTION: {
                    actions: 'updateDescriptionInContext'
                },
                UPDATE_LEVEL: {
                    actions: 'updateLevelInContext'
                },
                UPDATE_THUMBNAIL: {
                    actions: 'updateThumbnailInContext'
                }
            }
        },
        editingExisting: {
            entry: [
                function() {
                    return console.log('[XState] Entering state: editingExisting');
                }
            ],
            on: {
                SAVE_COURSE: {
                    guard: 'isCourseSavable',
                    target: 'savingCourse',
                    actions: 'setSaveLoadingTrue'
                },
                PUBLISH_COURSE: {
                    guard: 'isCourseLoadedAndPublishable',
                    target: 'publishingCourse',
                    actions: 'setPublishLoadingTrue'
                },
                UPDATE_TITLE: {
                    actions: 'updateCourseTitle'
                },
                UPDATE_DESCRIPTION: {
                    actions: 'updateDescriptionInContext'
                },
                UPDATE_LEVEL: {
                    actions: 'updateLevelInContext'
                },
                UPDATE_THUMBNAIL: {
                    actions: 'updateThumbnailInContext'
                }
            }
        },
        savingCourse: {
            entry: [
                function() {
                    return console.log('[XState] Entering state: savingCourse');
                }
            ],
            invoke: {
                id: 'saveCourseActorInvoked',
                src: 'saveCourseActor',
                input: function(param) {
                    var context = param.context, event = param.event;
                    var saveEvent = event;
                    var basicInfo = saveEvent.basicInfoData;
                    // SAVE_COURSE 이벤트에 포함된 curriculumData를 우선적으로 사용
                    var curriculumDataFromEvent = saveEvent.curriculumData;
                    console.log('[courseEditPageMachine] Curriculum data from SAVE_COURSE event:', curriculumDataFromEvent);
                    // curriculumActorRef가 있고, 이벤트에서 curriculumData를 받지 못한 경우 fallback으로 사용 (선택적)
                    var finalCurriculumData = curriculumDataFromEvent;
                    if (finalCurriculumData === undefined && context.curriculumActorRef) {
                        var _curriculumSnapshot_context;
                        var curriculumSnapshot = context.curriculumActorRef.getSnapshot();
                        finalCurriculumData = (_curriculumSnapshot_context = curriculumSnapshot.context) === null || _curriculumSnapshot_context === void 0 ? void 0 : _curriculumSnapshot_context.sections;
                        console.log('[courseEditPageMachine] Fallback: Curriculum data from actor snapshot for save:', finalCurriculumData);
                    } else if (finalCurriculumData === undefined) {
                        console.warn('[courseEditPageMachine] No curriculum data from event and no curriculum actor ref, or curriculumData was explicitly undefined in event.');
                        finalCurriculumData = []; // 또는 적절한 기본값
                    }
                    var payload = {
                        courseId: context.courseId,
                        data: {
                            basicInfo: basicInfo,
                            curriculum: finalCurriculumData
                        },
                        deps: context.dependencies
                    };
                    console.log('[courseEditPageMachine] Preparing input for saveCourseActor:', JSON.parse(JSON.stringify(payload)));
                    return payload;
                },
                onDone: [
                    {
                        guard: function(param) {
                            var context = param.context, event = param.event;
                            var _event_output;
                            console.log('[courseEditPageMachine] saveCourseActor onDone guard check. Context courseId:', context.courseId, 'Event output:', event.output); // event.output 타입 명시
                            return context.courseId === 'new' || hasOutput(event) && ((_event_output = event.output) === null || _event_output === void 0 ? void 0 : _event_output.id) === context.courseId;
                        },
                        target: 'editingExisting',
                        actions: [
                            'assignSaveSuccess',
                            function() {
                                return console.log('[courseEditPageMachine] saveCourseActor onDone (first path)');
                            }
                        ]
                    },
                    {
                        target: 'editingExisting',
                        actions: [
                            'assignSaveSuccess',
                            function() {
                                return console.log('[courseEditPageMachine] saveCourseActor onDone (fallback path)');
                            }
                        ]
                    }
                ],
                onError: {
                    target: 'editingExisting',
                    actions: [
                        'assignSaveError',
                        function() {
                            return console.log('[courseEditPageMachine] saveCourseActor onError');
                        }
                    ]
                }
            }
        },
        publishingCourse: {
            entry: [
                function() {
                    return console.log('[XState] Entering state: publishingCourse');
                }
            ],
            invoke: {
                id: 'publishCourseActorInvoked',
                src: 'publishCourseActor',
                input: function(param) {
                    var context = param.context;
                    return {
                        courseId: context.courseId,
                        deps: context.dependencies
                    };
                },
                onDone: {
                    target: 'editingExisting',
                    actions: 'assignPublishSuccess'
                },
                onError: {
                    target: 'editingExisting',
                    actions: 'assignPublishError'
                }
            }
        }
    },
    on: {
        CHANGE_TAB: {
            actions: 'updateCurrentTab'
        },
        // RELOAD_COURSE 와 LOAD_COURSE는 이제 페이지 컴포넌트에서 loaderMachine으로 전달됨.
        UPDATE_BASIC_INFO_DIRTY: {
            actions: 'updateBasicInfoDirty'
        },
        UPDATE_CURRICULUM_DIRTY: {
            actions: 'updateCurriculumStateFromChild'
        },
        CHILD_CURRICULUM_UPDATED: {
            actions: [
                'updateCurriculumStateFromChild'
            ]
        },
        FORWARD_TO_CURRICULUM: {
            actions: 'forwardToCurriculumActor'
        }
    }
});
